import React, { useState, useContext, useEffect, useRef } from 'react';
import { Col, Row, Form, Button, InputGroup } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import Preloader from "../../components/Preloader/Preloader";
import { Card, CardBody  } from "react-bootstrap";
import axios from "axios";
import { fetchAuthSession } from 'aws-amplify/auth';
import { useSnackbar } from 'notistack';

const config = require('../../config.json');

export default function PaymentForm(props) {
    const {formType, newToggle, handleSearch} = props;
    const {loggedUser, generateOrderNo, subscriberDetails} = useContext(ProductContext);
    const [paymentDetails, setPaymentDetails] = useState({paymentID:'', subscriberID:'', transactionDate:'', txStatus:'', paymentMode:'Cash', paymentPartner:'',
    gatewayName:'',currency:'', referenceId:'', orderAmount:'', bankName:'', bankAddress:'', years:1, discountAmount:'', discountValue:'', gstCharges:'', 
    copies:'', packageAmount:'', startDate:'', endDate:'', comments:''});
    const [loaded, setLoaded]=useState(true);    
    const [viewOnly, setViewOnly] = useState(true);
    const inputYears=useRef(null);
    const inputPaymentMode=useRef(null);
    const inputEndDate=useRef(null);
    const inputStartDate=useRef(null);
    const inputOrderAmount=useRef(null);
    const inputTransactionDate=useRef(null);
    const inputComments=useRef(null);
    const inputReferenceID=useRef(null);
    const inputCurrency=useRef(null);
    const inputBankName=useRef(null);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(()=>{
        //console.log("Props : ", props);
        if(formType==="New"){
            resetValues();
            assignNewSubcriptionDates();
            setViewOnly(false);
        }else if (formType==="View"){
            setViewOnly(true);
            assignValues();
        }else if(formType==="Edit"){
            setViewOnly(false);
            assignValues();
        }
        //inputStartDate.current.focus();
        //initializeValues();
        //setEnrollCourse(selectedItem.selectedCourse);
        //setFinalAmount(selectedOptionDetails.courseAmount);
    },[])

    function generateDate() {
        const current_datetime = new Date();
        var tempUserId = "";
        const date_year = (current_datetime.getFullYear()).toString();
        var date_month = (current_datetime.getMonth() + 1).toString();
        var month_value = "";
        date_month.length === 1 ? (month_value = month_value.concat(0, date_month)) : (month_value = date_month);
        var date_date = (current_datetime.getDate().toString());
        var date_value = "";
        date_date.length === 1 ? (date_value = date_value.toString().concat(0, date_date)) : (date_value = date_date);
        var date_hours = (current_datetime.getHours().toString());
        var hours_value = "";
        date_hours.length === 1 ? (hours_value = hours_value.toString().concat(0, date_hours)) : (hours_value = date_hours);
        var date_minutes = (current_datetime.getMinutes().toString());
        var minutes_value = "";
        date_minutes.length === 1 ? (minutes_value = minutes_value.toString().concat(0, date_minutes)) : (minutes_value = date_minutes);
        const accountNo = tempUserId.concat(date_year, "-", month_value, "-", date_value);
        //setUserId(accountNo);
        //setMemberInfo({...memberInfo, userId:accountNo});
        return accountNo;
        //console.log("acc : ", accountNo);
    }

    const resetValues=()=>{
        const todayDate=generateDate();
        setPaymentDetails({...paymentDetails, paymentID:'', subscriberID:'', transactionDate:todayDate, txStatus:'', paymentMode:'Cash', paymentPartner:'',
    gatewayName:'',currency:'INR', referenceId:'', orderAmount:250, bankName:'', bankAddress:'', years:1, discountAmount:0, discountValue:0, gstCharges:0, 
    copies:'', packageAmount:'250', startDate:todayDate, endDate:todayDate});
    }

    const validateFields=()=>{
        var validateResult="PASS";
        if(paymentDetails.paymentMode==="Cheque"){
            if(paymentDetails.referenceId===""){
                enqueueSnackbar("Enter Cheque Number!",{variant : 'info'});
                validateResult="FAIL";
            }else if(paymentDetails.bankName===""){
                enqueueSnackbar("Enter Bank Name!",{variant : 'info'});
                validateResult="FAIL";
            }
        } else if(paymentDetails.paymentMode==="DD"){
            if(paymentDetails.referenceId===""){
                enqueueSnackbar("Enter DD Number!",{variant : 'info'});
                validateResult="FAIL";
            }else if(paymentDetails.bankName===""){
                enqueueSnackbar("Enter Bank Name!",{variant : 'info'});
                validateResult="FAIL";
            }
        }else if(paymentDetails.paymentMode==="Online"){
            if(paymentDetails.referenceId===""){
                enqueueSnackbar("Enter Online Transaction Number!",{variant : 'info'});
                validateResult="FAIL";
            }else if(paymentDetails.bankName===""){
                enqueueSnackbar("Enter Bank Name!",{variant : 'info'});
                validateResult="FAIL";
            }
        }else if(paymentDetails.transactionDate===""){
            enqueueSnackbar("Payment Date cannot be null!",{variant : 'info'});
            validateResult="FAIL";
        }else if(paymentDetails.years<1){
            enqueueSnackbar("Enter Valid years!",{variant : 'info'});
            validateResult="FAIL";
        }else if(paymentDetails.startDate===""){
            enqueueSnackbar("New Subscription Start date empty!",{variant : 'info'});
            validateResult="FAIL";
        }else if(paymentDetails.endDate===""){
            enqueueSnackbar("New Subscription End date empty!",{variant : 'info'});
            validateResult="FAIL";
        }else if(paymentDetails.orderAmount<1){
            enqueueSnackbar("Enter valid Amount!",{variant : 'info'});
            validateResult="FAIL";
        }else{
            validateResult="PASS";
        }
        return validateResult;
    }

    const assignNewSubcriptionDates=()=>{
        var tempDate= new Date(subscriberDetails.endDate);
        tempDate.setDate(tempDate.getDate() + 1);
        var date_date = ((tempDate.getDate()).toString());
        var date_value="";
        date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
        var date_month = (tempDate.getMonth() + 1).toString();
        var month_value="";
        date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
        const tempYear = (tempDate.getFullYear()).toString();
        var tempRenew = "";
        const newStartDate = tempRenew.concat(tempYear,"-",month_value,"-",date_value);
        const tempendDate= new Date(subscriberDetails.endDate);
        var date_date1 = ((tempendDate.getDate()).toString());
        var date_value1="";
        date_date1.length===1?(date_value1=date_value1.toString().concat(0,date_date1)):(date_value1=date_date1);
        var date_month1 = (tempendDate.getMonth() + 1).toString();
        var month_value1="";
        date_month1.length===1? (month_value1=month_value1.concat(0,date_month1)):(month_value1=date_month1);
        const tempYear1 = (tempendDate.getFullYear()+1).toString();
        var tempRenew1 = "";
        const newEndDate = tempRenew1.concat(tempYear1,"-",month_value1,"-",date_value1);

        //setSubscribedAmount(amount);
        //setFinalAmount(amount);
        //setsubscriberDetails({...subscriberDetails, endDate:renewDate});
        setPaymentDetails({...paymentDetails, 
            years: 1,
            packageAmount:250,
            orderAmount:250,
            startDate:newStartDate,
            endDate:newEndDate
        });
    }

    const assignValues=()=>{
        setPaymentDetails(props.selectedItem);
        //console.log("props : ", props);
    }
    
    const handlePayment=async(event)=>{
        event.preventDefault();
        try{
            const validateResult=validateFields();
            //console.log("validation : ", validateResult);
            if(validateResult==="PASS"){
            setLoaded(false);
            const tdate=generateDate();
            const paymentid=generateOrderNo();
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const {transactionDate, paymentMode,currency, referenceId, orderAmount, bankName, bankAddress, years, discountAmount, discountValue, gstCharges, packageAmount, startDate, endDate, comments}   = paymentDetails;         
            const params={
                paymentID:paymentid,
                paymentMode:paymentMode,
                paymentPartner:paymentMode,
                orderAmount:orderAmount,
                txStatus:"TXN_SUCCESS",
                subscriberID:subscriberDetails.subscriberID,
                transactionDate:transactionDate,
                referenceId:"NA",
                currency:currency,
                discountAmount:discountAmount,
                discountValue:discountValue,
                bankName:bankName,
                packageAmount:packageAmount,
                updatedBy:loggedUser.name,
                updatedOn:tdate,
                endDate:endDate,
                startDate:startDate,
                copies:subscriberDetails.copies,
                gstCharges:gstCharges,
                years:years,
                bankAddress:bankAddress,
                comments:comments
            };
            await axios.post(`${config.api.invokeUrl}/payments/${paymentid}`, params,{
                headers: {
                  Authorization: idToken,
                  'x-api-key':config.api.key
                }})
                .then(async(response)=>{
                 enqueueSnackbar("Payment successfully processed!",{variant : 'success'});
                resetValues();
                window.scrollTo(0,0); 
                setLoaded(true);
                handleSearch();
                newToggle();
                }).catch((error)=>{
                    enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
                  window.scrollTo(0,0); 
                  setLoaded(true);
                })
            }
    }catch(error){
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);      
    }
    }

    const handlePaymentEdit=async(event)=>{
        event.preventDefault();
        try{
            const validateResult=validateFields();
            //console.log("validation : ", validateResult);
            if(validateResult==="PASS"){
            setLoaded(false);
            const tdate=generateDate();
            //const paymentid=generateOrderNo();
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const {paymentID, transactionDate, txStatus, paymentMode,currency, referenceId, orderAmount, bankName, bankAddress, years, discountAmount, discountValue, gstCharges, packageAmount, startDate, endDate, comments}   = paymentDetails;         
            const params={
                paymentID:paymentID,
                paymentMode:paymentMode,
                paymentPartner:paymentMode,
                orderAmount:orderAmount,
                txStatus:txStatus,
                subscriberID:subscriberDetails.subscriberID,
                transactionDate:transactionDate,
                referenceId:referenceId,
                currency:currency,
                discountAmount:discountAmount,
                discountValue:discountValue,
                bankName:bankName,
                packageAmount:packageAmount,
                updatedBy:loggedUser.name,
                updatedOn:tdate,
                endDate:endDate,
                startDate:startDate,
                copies:subscriberDetails.copies,
                gstCharges:gstCharges,
                years:years,
                bankAddress:bankAddress,
                comments:comments
            };
            //console.log("Params : ", params);
            const paymentid=paymentID;
            //await axios.post(`${config.api.invokeUrl}/payments/${paymentid}`, params,{
            await axios.patch(`${config.api.invokeUrl}/payments/${paymentid}`, params,{
                headers: {
                  Authorization: idToken,
                  'x-api-key':config.api.key
                }})
                .then(async(response)=>{
                  //console.log("response : ", response); 
                 //fetchCurrentYearDetails(selectedBatch);
                 enqueueSnackbar("Payment successfully Updated!",{variant : 'success'});
                resetValues();
                window.scrollTo(0,0); 
                setLoaded(true);
                handleSearch();
                newToggle();
                }).catch((error)=>{
                    enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
                  window.scrollTo(0,0); 
                  setLoaded(true);
                })
            }
    }catch(error){
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);      
    }
    }

    const handleYearChange =(tyears)=>{
        var amount=250*tyears*subscriberDetails.copies;
        //console.log("Amount : ", amount);
        const tempDate= new Date(subscriberDetails.endDate);
        const tempYear = (tempDate.getFullYear()+parseInt(tyears)).toString();
        var date_month = (tempDate.getMonth() + 1).toString();
        var month_value="";
        date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
        var date_date = (tempDate.getDate().toString());
        var date_value="";
        date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
        var tempRenew = "";
        const renewDate = tempRenew.concat(tempYear,"-",month_value,"-",date_value);
        
        //setSubscribedAmount(amount);
        //setFinalAmount(amount);
        //setsubscriberDetails({...subscriberDetails, endDate:renewDate});
        setPaymentDetails({...paymentDetails, 
            years: tyears,
            packageAmount:250,
            orderAmount:amount,
            //startDate:subscriberDetails.startDate,
            endDate:renewDate
        });
    }

    const handleEventKey=(event, item)=>{
        //console.log("event : ", event);
        if(event.key === 'Enter'){
            if(item==="1"){
                inputEndDate.current.focus();
            }else if(item==="2"){
                inputPaymentMode.current.focus();
            }else if(item==="3"){
                inputCurrency.current.focus();
            }else if(item==="4"){
                inputYears.current.focus();
            }else if(item==="5"){
                inputOrderAmount.current.focus();
            }else if(item==="8"){
                inputTransactionDate.current.focus();
            }else if(item==="9"){
                inputComments.current.focus();
            }
        }
    }

    const handleNewSubstartChange=(event)=>{
        const tyears=paymentDetails.years;
        const tempDate= new Date(event.target.value);
        const tempYear = (tempDate.getFullYear()+parseInt(tyears)).toString();
        var date_month = (tempDate.getMonth() + 1).toString();
        var month_value="";
        date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
        var date_date = (tempDate.getDate().toString());
        var date_value="";
        date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
        var tempRenew = "";
        const renewDate = tempRenew.concat(tempYear,"-",month_value,"-",date_value);

        setPaymentDetails({...paymentDetails, 
            startDate: event.target.value,
            endDate:renewDate
        });
    }

  return (
    <div>  
    <Preloader show={loaded ? false : true} />
    <div className="table-settings mb-4">
    {formType==="View" || formType==="Edit"?null : <><Row>
    <Col md={6} className="mb-3">
    <Form.Label>Name : {subscriberDetails.title}.{subscriberDetails.subscriberName} </Form.Label>
    </Col>
    <Col md={6} className="mb-3">
    <Form.Label>ID : {subscriberDetails.subscriberID} </Form.Label>
    </Col>
    </Row>
    <Row>
    <Col md={6} className="mb-3">
    <Form.Label>Category : {subscriberDetails.categoryID} </Form.Label>
    </Col>
    <Col md={6} className="mb-3">
    <Form.Label>copies : {subscriberDetails.copies} </Form.Label>
    </Col>
  </Row></>}
  <Card >
    <CardBody>
      <Form.Label>Current Subscription Details :  </Form.Label>
  <Row>
    <Col md={6} className="mb-3">
    <Form.Label>Start Date :  </Form.Label>
     <InputGroup>
          <InputGroup.Text>
          </InputGroup.Text>
          <Form.Control type="date" disabled={viewOnly} value={subscriberDetails.startDate} />
        </InputGroup>
        </Col>
        <Col md={6} className="mb-3">
        <Form.Label>End Date :  </Form.Label>
     <InputGroup>
          <InputGroup.Text>
          </InputGroup.Text>
          <Form.Control type="date" disabled={viewOnly} value={subscriberDetails.endDate} />
        </InputGroup>
        </Col>    
    </Row>   
    </CardBody>
  </Card>
    
    <div  style={{paddingTop:"20px"}}>
        <Card>
            <CardBody>
<Form.Label>New Subscription Details :  </Form.Label>
    <Row>
    <Col md={6} className="mb-3">
    <Form.Label>Start Date :  </Form.Label>
     <InputGroup>
          <InputGroup.Text>
          </InputGroup.Text>
          <Form.Control type="date" autoFocus value={paymentDetails.startDate} disabled={viewOnly}
          onChange={(event)=>{handleNewSubstartChange(event)}}
          ref={inputStartDate} onKeyDown={event=>{handleEventKey(event,"1")}} />
        </InputGroup>
        </Col>
        <Col md={6} className="mb-3">
        <Form.Label>End Date :  </Form.Label>
     <InputGroup>
          <InputGroup.Text>
          </InputGroup.Text>
          <Form.Control type="date" value={paymentDetails.endDate} disabled={viewOnly}
          onChange={(event)=>{setPaymentDetails({...paymentDetails, endDate: event.target.value})}}
          ref={inputEndDate} onKeyDown={event=>{handleEventKey(event,"2")}} />
        </InputGroup>
        </Col>    
    </Row>
<Row>
    <Col md={4} className="mb-3">
    <Form.Label>Mode of Payment:  </Form.Label>
     <Form.Group id="searchstud">
           <Form.Select defaultValue="Cash" value={paymentDetails.paymentMode} disabled={viewOnly}
           onChange={(event)=>{setPaymentDetails({...paymentDetails, paymentMode: event.target.value})}}
           ref={inputPaymentMode} onKeyDown={event=>{handleEventKey(event,"3")}} >
             <option value="Cash">Cash</option>
             <option value="Cheque">Cheque</option>
             <option value="Bank Transfer">Bank Transfer</option>
             <option value="Demand Draft">Demand Draft</option>
             <option value="Donation">Donation</option>
             <option value="Money Order">Money Order</option>
             <option value="Online">Online</option>

           </Form.Select>
         </Form.Group>
        </Col>
        <Col md={4} className="mb-3">
    <Form.Label>Currency:  </Form.Label>
    <Form.Group id="currency">
           
    <Form.Select defaultValue="INR" value={paymentDetails.currency} disabled={viewOnly}
           onChange={(event)=>{setPaymentDetails({...paymentDetails, currency: event.target.value})}}
           ref={inputCurrency} onKeyDown={event=>{handleEventKey(event,"4")}} >
             <option value="INR">INR</option>
             <option value="USD">USD</option>
           </Form.Select>
         </Form.Group>
        </Col>
    <Col md={4} className="mb-3">
    <Form.Label>Years:  </Form.Label>
    <Form.Group id="searchstud">
    <Form.Control type="number" value={paymentDetails.years} disabled={viewOnly}
          onChange={(event)=>{handleYearChange(event.target.value)}}
          ref={inputYears} onKeyDown={event=>{handleEventKey(event,"5")}} />
         </Form.Group>
        </Col>
    
    </Row> 
    {paymentDetails.paymentMode==="Cash"?null: <Row>
    <Col md={6} className="mb-3">
    <Form.Label>{paymentDetails.paymentMode} No:  </Form.Label>
     <InputGroup>
          <InputGroup.Text>
          </InputGroup.Text>
          <Form.Control type="text" placeholder="Cheque / DD / Transaction No" value={paymentDetails.referenceId} 
          disabled={viewOnly} ref={inputReferenceID} onKeyDown={event=>{handleEventKey(event,"6")}}
          onChange={(event)=>{setPaymentDetails({...paymentDetails, referenceId: event.target.value})}}/>
        </InputGroup>
    </Col>
    <Col md={6} >
      <Form.Label>Bank Name:  </Form.Label>
    
      <InputGroup>
          <InputGroup.Text>
          </InputGroup.Text>
          <Form.Control type="text" placeholder="Bank Name" value={paymentDetails.bankName} disabled={viewOnly}
            ref={inputBankName} onKeyDown={event=>{handleEventKey(event,"7")}}
          onChange={(event)=>{setPaymentDetails({...paymentDetails, bankName: event.target.value})}}/>
        </InputGroup>
      </Col>
    </Row>}
    <Row>
    <Col md={6} className="mb-3">
    <Form.Label>Amount to be Paid :  </Form.Label>
    <InputGroup>
         
    <Form.Control type="number" value={paymentDetails.orderAmount} disabled={viewOnly} 
    onKeyDown={event=>{handleEventKey(event,"8")}} ref={inputOrderAmount}/>
          
        </InputGroup>
        </Col>
      <Col  md={6} >
      <Form.Label>Date of Payment :  </Form.Label>
      <InputGroup>
         
          <Form.Control type="date" placeholder="Paid on" value={paymentDetails.transactionDate} disabled={viewOnly}
          onChange={(event)=>{setPaymentDetails({...paymentDetails, transactionDate: event.target.value})}}
          onKeyDown={event=>{handleEventKey(event,"9")}} ref={inputTransactionDate}/>
        </InputGroup> 
      </Col>
      
    </Row> 
    <Row>
    <Form.Label>Comments:  </Form.Label>
    
    <InputGroup>
        <InputGroup.Text>
        </InputGroup.Text>
        <Form.Control type="text" placeholder="Comments..." value={paymentDetails.comments} disabled={viewOnly}
        onChange={(event)=>{setPaymentDetails({...paymentDetails, comments: event.target.value})}}
        ref={inputComments} onKeyDown={event=>{handleEventKey(event,"10")}} />
      </InputGroup>

    </Row>
            </CardBody>
        </Card>
    </div>
    
   
   {/*} <Row>
    <Col md={6} className="mb-3">
    <Form.Check type="checkbox">
        <FormCheck.Input id="defaultCheck5" className="me-2" checked={concessionEnabled} onChange={(event)=>{handleConcessionCheck(event)}}/>
        <FormCheck.Label htmlFor="defaultCheck5" className="mb-0">Process Concession</FormCheck.Label>
    </Form.Check>
    </Col>
    {concessionEnabled?
    <Col md={6} className="mb-3">
    <Form.Label>Concession Amount :  </Form.Label>
    <InputGroup>
        <Form.Control type="number" value={concessionValue} onChange={(event)=>{handleConcessionUpdate(event)}} />
    </InputGroup>
    </Col>:null}
    </Row>*/}
    {/*<Row>
    <Col md={6} className="mb-3">
    <Form.Check type="checkbox">
        <FormCheck.Input id="donationCheck5" className="me-2" checked={donationEnabled} onChange={(event)=>{handleDonationCheck(event)}}/>
        <FormCheck.Label htmlFor="defaultCheck5" className="mb-0">Process Donation</FormCheck.Label>
    </Form.Check>
    </Col>
    {donationEnabled?
    <Col md={6} className="mb-3">
    <Form.Label>Donation Amount :  </Form.Label>
    <InputGroup>
        <Form.Control type="number" value={donationValue} onChange={(event)=>{handleDonationUpdate(event)}} />
    </InputGroup>
    </Col>:null}
    </Row>*/}
    <Row>
    {formType==="New"?<div className="text-center mb-2 mb-md-0">
    <Button variant="primary" type="submit" onClick={(event)=>{handlePayment(event)}}>Save</Button>
      </div>:formType==="Edit"?<div className="text-center mb-2 mb-md-0">
    <Button variant="primary" type="submit" onClick={(event)=>{handlePaymentEdit(event)}}>Update</Button>
      </div>:null}
    </Row>
  </div></div>
  )
}
